import React from "react";
import Card from "../Card/Card";
import "./Awards.css";

function Awards() {
  return (
    <div className="awards">
      <h2>Awards</h2>
      <hr></hr>
      <div className="row ">
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards40.jpg"
            title=" K. NIHARIKA 20R01A0433  "
            text2=" 3rd Prize in Cartoon Designing - International Biodiversity Day 2024 by State Government "
          />
        </div>
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards39.jpg"
            title=" Haritha Chethuri 22R01A6611"
            text2=" 2nd Prize in Cartoon Designing - International Biodiversity Day 2024 by State Government "
          />
        </div>
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards38.jpg"
            title=" M. PAVANI ALEKHYA 22R01A6741 "
            text2=" 3rd Prize in Traditional Dance - International Biodiversity Day 2024 by State Government "
          />
        </div>
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards37.jpg"
            title=" BHAVANA & TEAM - 2nd Year  "
            text2=" 2nd Prize in Traditional Dance - International Biodiversity Day 2024 by State Government "
          />
        </div>
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards36.jpg"
            title=" K.SRI VAISHNAVI 23R01A66F5  "
            text2=" 1st Prize in Traditional Dance - International Biodiversity Day 2024 by State Government "
          />
        </div>
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards35.jpg"
            title=" AISHWARYA RAGI 22R01A66B3 "
            text2=" 1st Prize in Photography - International Biodiversity Day 2024 by State Government "
          />
        </div>
      
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards42.jpg"
            title=" G. KRITHIKA 22R01A0425 "
            text2=" 1st Prize in Story Writing - State Level Youth Festival by State Government "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards41.jpg"
            title=" M. DHANUSH REDDY 22R01A7342 "
            text2=" 1st Prize in Mobile Photography - State Level Youth Festival by State Government "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards34.jpg"
            title=" CH.DIVYA & TEAM 2nd Year "
            text2=" 2nd Prize in Folk Dance - District Level Youth Festival - 2023 by State Government "
          />
        </div>
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards33.jpg"
            title=" Y. NAGA TEJA REDDY 22R01A66K3 "
            text2=" 1st Prize in Poster Making - District Level Youth Festival - 2023 by State Government "
          />
        </div>  
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards32.jpg"
            title=" M. DHANUSH REDDY 22R01A7342 "
            text2=" 2nd Prize in Mobile Photography - District Level Youth Festival - 2023 by State Government "
          />
        </div>
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards31.jpg"
            title=" G. KRITHIKA 22R01A0425 "
            text2=" 2nd Prize in Story Writing - District Level Youth Festival - 2023 by State Government "
          />
        </div>
      <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards26.jpg"
            title=" KAMSETTY RADHA 21R01A05M6 "
            text2=" Winner in Elocution Competition - Paying Homage to the National Leaders by NYKS Government of Telangana "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards19.jpg"
            title=" M. DHANUSH REDDY 22R01A7342 "
            text2=" 2nd Prize in Insta Reel Exploring Contest - Hyderabad Liberation Day 2023 by NYKS Government of Telangana "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards16.jpg"
            title=" K. NARESH 21R01A04N7 "
            text2=" 2nd Prize in Photography Contest - Hyderabad Liberation Day 2023 by NYKS Government of Telangana "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards18.jpg"
            title=" M. DHANUSH REDDY 22R01A7342 "
            text2=" 1st Prize in Short Film Making Competition - World Environmental Day 2023 by EPTRI Government of Telangana "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards25.jpg"
            title=" J. CHANDRIKA  22R01A6687 "
            text2=" 1st Prize in Poetry Writing - Telangana Formation Day 2023 by State Government "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards15.jpg"
            title=" Y. NAGA TEJA REDDY 22R01A66K3 "
            text2=" 1st prize in Cartoon Designing - International Biodiversity Day 2023 by State Government "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards20.jpg"
            title=" P. SURYA PRAKASH RAJ 22R01A7349 "
            text2=" 3rd Prize in Mobile Photography - District Level Yuva Utsav 2023 by NYKS Government of Telangana "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards17.jpg"
            title=" J. CHANDRIKA 22R01A6687 "
            text2=" 2nd Prize in Poetry Writing - District Level Yuva Utsav 2023 by NYKS Government of Telangana "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards22.jpg"
            title=" K. NIHARIKA 20R01A0433 "
            text2=" 1st Prize in Painting - District Level Yuva Utsav 2023 by NYKS Government of Telangana "
          />
        </div>
        
        
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards24.jpg"
            title=" G. SOLOMON & TEAM - NSS UNIT "
            text2=" 1st Prize in Cultural Fest - District Level Yuva Utsav 2023 by NYKS Government of Telangana "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards14.jpg"
            title=" SYEDA FATHIMA 22R01A7355 "
            text2=" 2nd prize in Eassy Writing - International Biodiversity Day 2023 by State Government "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards13.jpg"
            title=" B. SHARANYA REDDY 22R01A7376"
            text2=" 1st prize in Eassy Writing - International Biodiversity Day 2023 by State Government "              
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards12.jpg"
            title=" BHAVANA & TEAM - 1st Year "
            text2=" 1st prize in Traditional Dance - International Biodiversity Day 2023 by State Government"
          />
        </div>
        {/* <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards22.jpg"
            title=""
            text="                      "
          />
        </div> */}
        {/* <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards23.jpg"
            title=""
            text="                      "
          />
        </div> */}
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards11.jpg"
            title=" K. NIHARIKA 22R01A0433  "
            text2=" 1st prize in Arts & Painting - International Biodiversity Day 2023 by State Government "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards10.jpg"
            title=" V. MANI SAI VARMA 19R01A0557 "
            text1=" Best Youth Conservator - Awarded Gold Medal "
            text2=" Sponsored by LSF - Youth Environmental Council Presented in 2023 "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards9.jpg"
            title="   S. JEETHENDRA   19R01A0192 "
            text1=" Best Social Worker - Awarded Gold Medal "
            text2=" Sponsored by Lee Shreyus Foundation Presented in 2023 "
          />
        </div>
         <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards8.jpg"
            title="  B. SHRAVAN 19R01A0112 "
            text2=" BEST NSS VOLUNTEER AWARD Presented in 2019 - 2022 "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards30.jpg"
            title=" S. JASHWANTH 21R05A6608 "
            text2=" BEST VOLUNTEER AWARD - 14th Tribal Youth Exchange Programme presented by NYKS Government of Telangana "
          />
        </div>
         <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards29.jpg"
            title=" K. PAVAN KUMAR 20R01A6729 "
            text2=" 1st Prize in playing Musical Instruments - State Level Youth Festival Government of Telangana - Warangal 2022 "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards7.jpg"
            title=" A. UMA SHANKER  Best Organizer Award "
            text2=" State Level Youth Festival Government of Telangana - Warangal 2022"
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards27.jpg"
            title=" V. MANI SAI VARMA 19R01A0557 "
            text2=" 1st Prize in Essay Writing Competition on 55th Engineering's Day 2022 by Institute of Engineer Government of Telangana "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards6.jpg"
            title=" J. NITHIN (21R01A0420)"
            text2=" Awarded Cash Prize for Essay Competition on 75th Azadi Ka Amrit Mahotsav - 2022 "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards5.jpg"
            title=" N. MAHESHWARI (21R01A04P7)"
            text2=" Awarded Cash Prize for Essay Competition on 75th Azadi Ka Amrit Mahotsav - 2022  "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards4.jpg"
            title=" PATTEWAR MAYURI (18R01A0539) "
            text2=" BEST NSS VOLUNTEER AWARD Presented in 2018 - 2021 "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards3.jpg"
            title=" P. GANGA CHANDHAR REDDY  (18R01A01A2)" 
            text2=" BEST NSS VOLUNTEER AWARD Presented in 2018 - 2021 "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards2.jpg"
            title="ABHISTI SEVA PURASKAR AWARD  - 2021"
            text2=" By Abhisti Welfare Society Governement of India - New Delhi "
          />
        </div>
        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards28.jpg" 
            title=" K. SANVITHA "
            text2=" 1st  Prize in Women Parliament Competition - National Science Day Celebrations 2020 by ENVIS - EPTRI Government of Telangana "
          />
        </div>

        <div className="col-lg-4 center">
          <Card
            img="../images/awards/awards1.jpg"
            title=" K. PRADEEP KUMAR "
            text2= " BEST NSS VOLUNTEER AWARD FROM JNTUH 2019 "
          />
        </div>
      </div>
    </div>
  );
}

export default Awards;
